require('./cardActivatorSuccess.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @ constants
const { PROC_ACTIVATE_CARD } = require('utilities/tagging');


const CardActivatorSuccess = props => {
    const { immCard } = props;
    const title = formatText('cardActivate-successMessage');
    const goBackButtonLabel = formatText('cardActivate-goToCardDetails').toUpperCase();
    const linkToMovements = '/myprofile/cards';
    const goBackButton = {
        label: goBackButtonLabel,
        url: linkToMovements
    };
    
    const cardStatus = formatText('card-statusEN VIGOR');
    
    return (
        <article className="card-activator-success">
            <WizardSuccess
                successMessage={title}
                processType={PROC_ACTIVATE_CARD}
                mainButton={goBackButton}
            >
                <section className="card-activator-success__content row">
                    <div className="col-xs-5-cc-6">
                        <CommercialAds
                            path="cards"
                            type="cards"
                            immCard={immCard}
                            size="medium"
                        />
                    </div>

                    <div className="col-xs-7-cc-6">
                        <div className="card-activator-success__card-status">
                            <FormattedText value="cardActivate-currentStatus" />:
                            <span className="card-activator-success__card-status-value">
                                {cardStatus}
                            </span>
                        </div>
                    </div>
                </section>
            </WizardSuccess>
        </article>
    );
};

CardActivatorSuccess.propTypes = {
    immCard: PropTypes.object.isRequired
};

module.exports = CardActivatorSuccess;
